export default __webpack_public_path__ + "static/media/app-store.c78ba864.png";